export default __webpack_public_path__ + "media/transfer_window/upsell-facebook-f63b6b66.jpg";